/* eslint-disable import/prefer-default-export */
import { warn } from '../../helpers/console';
/**
 * Warn users about problems when using `columnSorting` and `multiColumnSorting` plugins simultaneously.
 */

export function warnAboutPluginsConflict() {
  warn('Plugins `columnSorting` and `multiColumnSorting` should not be enabled simultaneously.');
}


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/es/plugins/multiColumnSorting/utils.js
// module id = QD4B
// module chunks = 0